import React, { useState, useEffect } from "react";
import { Card, Row, Col, CardBody, Alert } from "reactstrap";

import { Form, Input, Button, Checkbox } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

import dev from "../../src/img/18907.jpg";
import Navigation from "../components/Navigation";
import Footer from '../components/Footer'
import Authenticate from "../Logic/Auth/Auth";
import { Link } from "react-router-dom";
import { Firestore, Auth } from "../config/firebase";

export default function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setError] = useState("");

  useEffect(() => {
    const user = Auth.currentUser;
  });

  function handleSignin() {
    console.log(email, password);
    if (password && email) {
      Authenticate.SignIn({ email, password })
        .then(res => props.history.goBack())
        .catch(error => setError(error.message));
    }
  }

  function handleGoogleSignin() {
    Authenticate.SignInWithGoogle()
      .then(res => props.history.goBack())
      .catch(error => setError(error.message));
  }

  return (
    <>
      <Navigation />

      <Col md={12} lg={12}>
        <Row>
          <Col md={7} lg={7} className="d-none d-md-none d-lg-block">
            <img src={dev} style={{ width: "100%" }} alt="loin" />
          </Col>

          <Col md={5} lg={5} className="ml-auto mr-auto pt-5 pb-5">
            <Col className="ml-auto mr-auto pt-4 pb-4" md={10} lg={9}>
              <Card>
                <CardBody>
                  <h2 className="mb-3">Login</h2>
                  <p>Welcome back, login</p>

                  {errorMsg === "" ? (
                    ""
                  ) : (
                    <Alert color="danger">{errorMsg}</Alert>
                  )}
                  <Form name="basic" initialValues={{ remember: true }}>
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: "Please input your username!"
                        }
                      ]}
                    >
                      <Input
                        name="email"
                        autoComplete="email"
                        onChange={event => setEmail(event.target.value)}
                        prefix={
                          <UserOutlined className="site-form-item-icon" />
                        }
                        placeholder="Username"
                      />
                    </Form.Item>

                    <Form.Item
                      name="password"
                      placeholder="password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your password!"
                        }
                      ]}
                    >
                      <Input.Password
                        name="password"
                        autoComplete="current-password"
                        onChange={event => setPassword(event.target.value)}
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        placeholder="Password"
                      />
                    </Form.Item>

                    <Form.Item name="remember" valuePropName="checked">
                      <Checkbox>Remember me</Checkbox>
                    </Form.Item>

                    <Form.Item>
                      <Button
                        onClick={e => handleSignin()}
                        block
                        type="primary"
                        htmlType="submit"
                      >
                        Log In
                      </Button>

                      <Button
                        className="mt-2"
                        onClick={e => handleGoogleSignin()}
                        block
                        type="danger"
                      >
                        Google
                      </Button>
                    </Form.Item>
                  </Form>
                  <hr />

                  <Link href="/signup">
                    <Button block htmlType="submit">
                      Sign Up
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </Col>
          </Col>
        </Row>
      </Col>

      <Footer/>
    </>
  );
}
